
import { useState } from "react";
import Menu from '../menu/Menu';
import ChildSafety from "./childsafety";



export default function ChildSafetyScreen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <ChildSafety onOpenMenu={() => setIsMenuOpen(true)} />

      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white">
          <Menu isLoggedIn={true} onClose={() => setIsMenuOpen(false)} />
        </div>
      )}
    </>
  );
}